<template>
  <div>
    <el-container class="home_container">
      <el-header>
        <div class="home_title">
          <img :src="require('@/assets/LOGO003.jpg')" style="width: 160px; height: 56px;" @click="jump('/homePage')" />
          <!-- <i class="fa fa-globe"></i>
          <el-button class="home_title" @click="jump('/homePage')" type="text"><i>HR&nbsp;{{$t("home.system")}}</i></el-button> -->
        </div>
        <div class="home_userinfoContainer">
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link home_userinfo">
              {{currentUserName}}
              <i class="el-icon-arrow-down el-icon--right home_userinfo"></i>
            </span>
            <el-dropdown-menu slot="dropdown" style="text-align:center">
              <!-- <el-dropdown-item command="sysMsg" class="el-icon-error">{{$t("home.msg")}}</el-dropdown-item> -->
              <el-dropdown-item command="MyHome"><i class="fa fa-cog"></i>アカウント設定</el-dropdown-item>
              <el-dropdown-item command="logout" divided><i class="fa fa-stop-circle-o"></i>{{$t("home.logout")}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>

      <el-container>

        <el-aside :width="isCollapse?'63px':'200px'">

          <div class="toggle-button" @click="toggleCollapse">|||</div>
          <el-menu unique-opened="true" default-active="0" @open="handleOpen" @close="handleClose" :collapse="isCollapse" class="el-menu-vertical-demo" style="background-color: #ECECEC" router>
            <template v-for="(item,index) in this.$router.options.routes" v-if="!item.hidden">
              <el-submenu class="submenu" :index="index+''" v-if="item.children.length>1" :key="index">
                <template slot="title">
                  <i :class="item.iconCls"></i>
                  <span>{{$t(item.meta.localeName)}}</span>
                </template>
                <el-menu-item class="submenu_item" v-for="child in item.children" v-if="!child.hidden" :index="child.path" :key="child.path">{{$t(child.meta.localeName)}}</el-menu-item>
              </el-submenu>
              <template v-else>
                <el-menu-item :index="item.children[0].path">
                  <i :class="item.children[0].iconCls"></i>
                  <span slot="title">{{$t(item.children[0].meta.localeName)}}</span>
                </el-menu-item>
              </template>
            </template>
          </el-menu>
        </el-aside>

        <el-container>
          <el-main>
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item :to="{ path: '/homePage' }"><i class="fa fa-home"></i></el-breadcrumb-item>
              <el-breadcrumb-item v-text="$t(this.$router.currentRoute.meta.localeName)"></el-breadcrumb-item>
            </el-breadcrumb>
            <keep-alive>
              <router-view v-if="this.$route.meta.keepAlive"></router-view>
            </keep-alive>
            <router-view v-if="!this.$route.meta.keepAlive"></router-view>
          </el-main>
          <el-footer>
            <div class="link1112">
              <el-link href="https://www.hrbox.jp/" target="_blank">ホームページ</el-link>
              <el-link href="https://www.hrbox.jp/company.html" target="_blank">会社概要</el-link>
              <el-link href="https://www.hrbox.jp/protocol.html" target="_blank">利用規約</el-link>
              <el-link href="https://www.hrbox.jp/sup/#/" target="_blank">営業支援システム</el-link>
            </div>
            <div class="link2223">
              <el-link href="https://www.hrbox.jp/" target="_blank" :underline="false">© SENSE, Inc.</el-link>
            </div>
          </el-footer>
        </el-container>
      </el-container>
    </el-container>
  </div>

</template>
<script>
import { getRequest } from "../utils/api";
export default {
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    jump(path) {
      this.$router.replace(path);
    },
    toggleCollapse() {
      this.isCollapse = !this.isCollapse;
    },
    handleCommand(command) {
      var _this = this;
      if (command == "MyHome") {
        _this.$router.replace({ path: "/UserHome" });
      }
      if (command == "logout") {
        this.$confirm(
          this.$t("home.logout_confirm"),
          this.$t("home.alert_info"),
          {
            cancelButtonClass: "btn-custom-cancel",
            confirmButtonClass: "btn-custom-confirm",
            confirmButtonText: "OK",
            cancelButtonText: this.$t("general.cancel"),
            type: "warning",
          }
        ).then(
          function () {
            getRequest("/logout");
            _this.currentUserName = "ゲスト";
            _this.$router.replace({
              path: "/",
            });
            window.localStorage.clear();
            window.sessionStorage.clear();
          },
          function () {
            //取消
          }
        );
      }
    },
  },
  mounted: function () {

    window.onstorage = (e) => {
      
      location.reload();
      


    };

    // window.addEventListener('setItem', () => {
    //   this.newVal = localStorage.getItem('watchStorage');
    //   alert(666);
    // })


    // window.onbeforeunload = e => {
    //   window.localStorage.clear();
    //   // alert("ご登録されているユーザーからログアウトしていいですか？行った変更が保存されない可能性があります。");
    //   return ''
    // };

    /**
     *判断浏览器窗口是刷新或者关闭操作
     * 无论任何浏览器不管是刷新或者是关闭都会执行下面两个方法 onbiforeunload  onunload
     * 根据时间差来实现
     * 在点击刷新或者关闭时开始计时记录下这一刻的时间戳
     * 因为刷新和关闭 在执行onunload方法时的时间不一样，一般情况下经过测试
     * 关闭时时间差不大于3毫秒
     * 刷新时即使只有一个简单的helloworld页面都不少于10毫秒
     * 而一般网站网页内容更多，时间差达到了100多毫秒
     *
     *
     * 下面方法的缺点是不管你开了多少窗口，都会在关闭一个窗口时清空所有localStorage缓存
     * 造成所有页面都需要重新登录，其实这也是针对项目而言的，目前本项目就不认为这是缺点
     * 而能更好的保护用户信息
     **/

    // let beginTime = 0;//开始时间
    // let differTime = 0;//时间差
    // window.onunload = function () {
    //   differTime = new Date().getTime() - beginTime;
    //   if (differTime <= 5) {
    //     window.localStorage.clear();
    //   }
    // };
    // window.onbeforeunload = function () {
    //   beginTime = new Date().getTime();

    // };

    var _this = this;
    getRequest("/currentUserName").then(
      function (msg) {
        if (window.localStorage.getItem('LoginUserId') > 0) {
          _this.currentUserName = msg.data;
        } else {
          _this.currentUserName = "ゲスト";
        }

      },
    );
  },
  data() {
    return {
      currentUserName: "",
      isCollapse: false,
    };
  },
};
</script>

<style>
.btn-custom-cancel {
  float: right;
  margin-left: 10px;
  margin-right: 10px;
  width: 90px;
}

.btn-custom-confirm {
  margin-left: 10px;
  margin-right: 10px;
  width: 90px;
}
</style>
<style scoped>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}
.home_userinfoContainer {
  display: inline;
  margin-right: 20px;
}
.submenu_item {
  margin-left: 17px !important;
  /* text-align: center !important; */
  /* text-align: center; */
}

.home_container {
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
}

.el-header {
  background-color: #20a0ff;
  color: #333;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.el-aside {
  background-color: #ececec;
}

.el-menu {
  border-right: none;
}

.el-main {
  background-color: #fff;
  color: #000;
  text-align: center;
}

/* .home_title {
  color: #fff;
  font-size: 30px;
  display: inline;
  font-weight: bold;
} */

.home_userinfo {
  color: #fff;
  cursor: pointer;
}

.style1 {
  margin-left: 69px;
  padding: 0px;
  text-align: left;
}

.link1112 {
  margin-left: 15px;
  float: left;
}

.link2223 {
  float: right;
  margin-right: 25px;
}

.link {
  margin-left: 15px;
}

.bg-purple-dark {
  margin-left: 69px;
  margin-right: 69px;
  padding: 0px;
  text-align: left;
  border-radius: 6px;
  background: #e5e9f2;
}

.toggle-button {
  background-color: #d0dce9;
  font-size: 10px;
  line-height: 36px;
  color: #fff;
  text-align: center;
  letter-spacing: 0.2em;
  cursor: pointer;
}

/* .el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
} */
</style>


// WEBPACK FOOTER //
// src/components/Home.vue